define('controller/login',['jquery', 'lodash', 'i18n', 'module', 'context', 'layout/loading-bar', 'layout/version-warning', 'ui/login/login', 'util/locale', 'core/store'], function ($, _, __, module, context, loadingBar, versionWarning, loginComponent, locale, store) {
  'use strict';

  var _defaults = {
    disableAutocomplete: false,
    enablePasswordReveal: false,
    disableAutofocus: false,
    message: {
      error: ''
    }
  };
  return {
    start: function start() {
      var conf = _.defaults({}, module.config(), _defaults);
      var login = loginComponent($('#login-box-inner-container'), conf);
      login.on('init', function () {
        loadingBar.start();
      }).after('render', function () {
        versionWarning.init();
        loadingBar.stop();
      }).on('submit.login', function () {
        loadingBar.start();
      });
      $('.small-navi').attr({
        dir: locale.getLanguageDirection(context.locale)
      });
    }
  };
});
